import React, { useEffect, useState, useRef } from "react";
import DataTables from "../../CommonDataTable/DataTable";
import config from "../../../../config/config";
import apiCalls from "../../../../config/apiCalls";
import filePath from "../../../../config/configSampleFiles";
import fetchMethodRequest from "../../../../config/service";
import RolePermissions from "../../CommonModals/Permissions";
import { useParams } from "react-router";
import SpeechToText from '../../CommonComponents/SpeechToText';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { File, Icon } from "lucide-react";

const FilesAnalysis = (props) => {
  const [languageData, setLanguageData] = useState({});
  const [rolePermission, setRolePermission] = useState("");
  const [rolesList, setRolesList] = useState([]);
  const [gotRoles, setgotRoles] = useState(false);
  const [editSelectedRecord, setEditSelectedRecord] = useState(
    window.location.href.includes("edit")
  );
  const [addSelectedRecord, setAddSelectedRecord] = useState(
    window.location.href.includes("create")
  );
  const [viewSelectedRecord, setViewSelectedRecord] = useState(
    window.location.href.includes("view")
  );
  const [isOpenFormModal, setIsOpenFormModal] = useState(false);
  const [openNewUserModal, setopenNewUserModal] = useState(false);
  const [item, setItem] = useState({});
  const [newFormFields, setNewFormField] = useState([]);

  // Main component
  const [graphsData, setGraphsData] = useState(null);
  const [tableData, setTableData] = useState(null);
  const [inputValue, setInputValue] = useState(''); // Initialize with empty string
  const inputRef = useRef(null);
  const [isLoading, setIsLoading] = useState(false);
  const [listening, setListening] = useState(false);
  const transcriptRef = useRef('');

  const params = useParams();

  useEffect(() => {
    getRoleListFromServer();
    let screenPermissions = RolePermissions.screenPermissions("Users");
    if (screenPermissions) {
      setRolePermission(screenPermissions);
    }
  }, []);

  // Add this missing function
  const getChangedRoleOptions = () => {
    let fields = getFormFields();
    if (fields && fields.length > 0) {
      for (let obj of fields) {
        if (obj.name === "role") {
          obj.options = rolesList && rolesList.length > 0 ? rolesList : [];
        }
      }
    }
    return fields;
  };

  const getTableFields = () => {
    let roleTypes = [
      {
        label: "All",
        value: null,
      },
      {
        label: "Admin",
        value: "Admin",
      },
      {
        label: "Super Admin",
        value: "Super Admin",
      },
      {
        label: "User",
        value: "User",
      },
    ];
    let StatusTypes = [
      {
        label: "All",
        value: null,
      },
      {
        label: "Active",
        value: "Active",
      },
      {
        label: "Inactive",
        value: "Inactive",
      },
      {
        label: "Pending",
        value: "Pending",
      },
    ];
    let data = [
      {
        textAlign: "center",
        width: 47,
        field: "Check Box",
        label: "Check Box",
        fieldType: "multiple",
        header: "",
        selectionMode: "multiple",
        show: false,
        mobile: true,
        displayInSettings: true,
        displayinlist: "false",
        displayinaddForm: "false",
        displayineditForm: "false",
        globalSearchField: "false",
        isFieldRequired: "false",
        tDisplay: true,
      },
      {
        textAlign: "center",
        width: 47,
        field: "Sno",
        label: "SNo",
        header: "SNo",
        filter: false,
        sortable: false,
        placeholder: "Search",
        displayinlist: "false",
        displayinaddForm: "false",
        displayineditForm: "false",
        globalSearchField: "false",
        isFieldRequired: "false",
        show: true,
        mobile: true,
        displayInSettings: false,
        tDisplay: true,
      },
      {
        name: "name",
        type: "text",
        placeholder: "Name",
        label: "Name",
        header: "Name",
        width: '70%',
        id: "name",
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "true",
        controllerName: null,
        fieldType: "redirectable",
        fileViewType: 'view',
        textAlign: "left",
        globalSearchField: "true",
        show: true,
        field: "name",
        isFieldRequired: "false",
        mobile: true,
        displayInSettings: true,
        tDisplay: true,
        displayIcon: true,
        fieldTypes: 'fileUpload',
        filter: true,
        redirectFilterField: 'parentFolderId',
        redirecTo: 'myDocuments',
        // iconName : 'folder',
        showIcon: true,
      },
      {
        name: "createdByName",
        type: "Text",
        placeholder: "Created By",
        label: "Created By",
        width: 120,
        header: "Created By",
        id: "createdByName",
        displayinlist: "true",
        globalSearchField: "true",
        controllerId: 1001,
        fieldType: "Text",
        textAlign: "left",
        show: true,
        field: "createdByName",
        mobile: true,
        filter: true,
        displayInSettings: true,
        displayinaddForm: "false",
        displayineditForm: "false",
        isFieldRequired: "false",
        tDisplay: true,
        customWidth: 'col-md-6 col-sm-12 pl-0',
        designIcon: 'user',
      },
      {
        name: "created",
        type: "date",
        placeholder: "Created",
        label: "Created",
        width: "10%",
        header: "Created",
        derivedValue: "created=undefined",
        actions: [],
        actionsNumber: [],
        id: "created",
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "true",
        globalSearchField: "true",
        controllerId: null,
        fieldType: "Date",
        dateFormat: config.dateFormat,
        textAlign: "center",
        disabled: true,
        show: true,
        field: "created",
        isFieldRequired: "false",
        mobile: true,
        displayInSettings: false,
        // tDisplay: true,
      },
      {
        name: "size",
        fieldName: "size",
        type: "text",
        placeholder: "Size",
        value: "",
        label: "Size",
        width: "20%",
        addFormOrder: 10,
        editFormOrder: 10,
        stringType: null,
        header: "Size",
        derivedValue: "size=undefined",
        capitalizeTableText: false,
        sortable: false,
        filter: false,
        id: "size",
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinregisterForm: "",
        displayinlist: "true",
        isFieldRequired: "false",
        required: false,
        globalSearchField: "true",
        controllerId: null,
        isClickable: "",
        isAddToIndex: false,
        textAlign: "left",
        show: true,
        field: "size",
        showOrHideFields: [],
        mobile: true,
        displayInSettings: true,
        tDisplay: true,
        fieldType: 'customType',
        customFieldType: 'memoryConversion',
        customWidth: 'col-md-6 col-sm-12',
        style: {
          width: '100%',
          textAlign: "center",
        },

      },
      {
        show: false,
        textAlign: "center",
        width: "10%",
        fieldType: "Actions",
        field: "Actions",
        header: "Actions",
        label: "Actions",
        filter: false,
        sortable: false,
        displayInSettings: true,
        displayinServer: "false",
        displayinlist: "true",
        displayinaddForm: "true",
        displayineditForm: "true",
        globalSearchField: "false",
        isFieldRequired: "false",
        mobile: true,
        tDisplay: true,
      },
    ];
    return data;
  };

  const getFormFields = () => {
    let statusTypes = [
      {
        label: "Active",
        value: "Active",
      },
      {
        label: "Inactive",
        value: "Inactive",
      },
      {
        label: "Pending",
        value: "Pending",
      },
    ];
    return [
      {
        name: "name",
        type: "text",
        placeholder: "Name",
        label: "Name",
        width: "30vw",
        id: "name",
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "true",
        controllerName: null,
        fieldType: "Link",
        globalSearchField: "true",
        show: true,
        isFieldRequired: "false",
        mobile: true,
        displayInSettings: true,
        isAddFormHidden: false,
        isEditFormHidden: false,
        customClass: 'col-sm-12',
      },
      {
        name: "createdByName",
        type: "Text",
        placeholder: "Created By",
        label: "Created By",
        width: 120,
        id: "createdByName",
        displayinlist: "true",
        globalSearchField: "true",
        controllerId: 1001,
        fieldType: "Text",
        show: true,
        mobile: true,
        filter: true,
        displayInSettings: true,
        displayinaddForm: "false",
        displayineditForm: "false",
        isFieldRequired: "false",
        isAddFormHidden: true,
        isEditFormHidden: true,
      },
      {
        name: "updatedByName",
        type: "Text",
        placeholder: "Updated By",
        label: "Updated By",
        width: 120,
        id: "updatedByName",
        displayinlist: "true",
        fieldType: "Text",
        show: true,
        filter: true,
        mobile: true,
        displayInSettings: true,
        displayinaddForm: "false",
        displayineditForm: "false",
        globalSearchField: "false",
        isFieldRequired: "false",
        isAddFormHidden: true,
        isEditFormHidden: true,
      },
      {
        name: "created",
        type: "date",
        placeholder: "Created",
        label: "Created",
        width: 90,
        derivedValue: "created=undefined",
        actions: [],
        actionsNumber: [],
        id: "created",
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "true",
        globalSearchField: "true",
        controllerId: null,
        fieldType: "Date",
        dateFormat: config.fileDateFormat,
        disabled: true,
        show: false,
        isFieldRequired: "false",
        mobile: true,
        displayInSettings: true,
        isAddFormHidden: false,
        isEditFormHidden: false,
      },
      {
        name: "updated",
        type: "date",
        placeholder: "Updated",
        label: "Updated",
        width: 90,
        derivedValue: "updated=undefined",
        actions: [],
        actionsNumber: [],
        id: "updated",
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "true",
        globalSearchField: "true",
        controllerId: null,
        fieldType: "Date",
        dateFormat: config.fileDateFormat,
        disabled: true,
        show: false,
        isFieldRequired: "false",
        mobile: true,
        displayInSettings: true,
        isAddFormHidden: false,
        isEditFormHidden: false,
      },
    ];
  };



  const getRoleListFromServer = async () => {
    let filterCriteria = {},
      url;
    filterCriteria.direction = "asc";
    url = `roles?filter=${JSON.stringify(filterCriteria)}`;
    fetchMethodRequest("GET", url)
      .then(async (res) => {
        if (res && res.roles && res.roles.length > 0) {
          let rolesList = [];
          for (let obj of res.roles) {
            if (obj.role) rolesList.push({ value: obj.role, label: obj.role });
          }
          setRolesList(rolesList);
          setgotRoles(true);
        }
      })
      .catch((err) => {
        setgotRoles(true);
        return err;
      });
  };

  const sendDataToServer = async (message) => {
    resetData();
    setIsLoading(true);
    const body = { query: message };
    let url = apiCalls.filesAnalysis + '/graphs';

    try {
      const response = await fetchMethodRequest("POST", url, body);
      if (response?.data?.graph && response?.data?.graph.length > 0) {
        setGraphsData(response.data);
        setTableData(null);
      }
      else if (response?.data?.results) {
        let data = response?.data?.results.map((item, index) => ({
          ...item,
          Sno: index + 1
        }));
        setTableData(data);
        setGraphsData(null);
      } else {
        console.log("Unexpected response format:", response);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSend = (e) => {
    e?.preventDefault();
    if (!inputValue.trim()) return;
    sendDataToServer(inputValue);
  };

  const voiceTextSend = (text) => {
    if (!text.trim()) return;
    sendDataToServer(text);
  };

  const handleSpeech = (message) => {
    if (!message) return;
    setInputValue(message);
  };
  const resetData = () => {
    setGraphsData(null);
    setTableData(null);
  }

  // Add cleanup function to prevent memory leaks
  useEffect(() => {
    return () => {
      resetData();
      setIsLoading(false);
    };
  }, []);
  return (
    <div className="container-fluid py-4 files-analysis-container">
      <div className={`${!graphsData && !tableData && !props.isHomePage ? 'd-flex justify-content-center align-items-center min-vh-75' : 'd-flex justify-content-center align-items-center'}`}>
        <div className={`mb-4 ${!graphsData && !tableData ? 'w-100' : ''}`} style={{ maxWidth: !graphsData && !tableData && !props.isHomePage ? '800px' : 'none' }}>
          <div className="row">
            <div className="col-4 d-flex align-items-center justify-content-center" style={{ padding: "0 10px" }}>
              {props.isHomePage && <img src={"img/free-vector.jpg"} className="mb-3 home-image" />}
            </div>
            <div className="col-8">
              <div className={`text-center ${props.isHomePage ? "mt-4" : "mb-4"}`}>
                {!props.isHomePage && <h3 className="voice-search-title gradient-text">Voice Based Search Analytics</h3>}
                <p className={` ${props.isHomePage ? "voice-search-heading" : "text-muted voice-search-subtitle"}`}>Ask questions and get insights from your data</p>
              </div>
              <div className="content-search-container">
                <div className="content-search-wrapper">
                  <div className="content-search-icon">
                    <svg focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
                      <path d="M15.5 14h-.79l-.28-.27A6.471 6.471 0 0 0 16 9.5 6.5 6.5 0 1 0 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"></path>
                    </svg>
                  </div>
                  <input
                    type="text"
                    value={inputValue}
                    onChange={(e) => {
                      const value = e.target.value;
                      setInputValue(value);

                      if (!value.trim()) {
                        resetData();
                      }
                    }}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter' && !isLoading) {
                        e.preventDefault();
                        transcriptRef.current = e.target.value;
                        if (!inputValue.trim()) {
                          resetData();
                          return;
                        }
                        handleSend(e);
                      }
                    }}
                    placeholder="Type your question here..."
                    ref={inputRef}
                    disabled={isLoading}
                    className="content-search-input"
                  />

                  <div className="content-input-actions">
                    <SpeechToText
                      inputRef={inputRef}
                      handleSpeech={handleSpeech}
                      listening={listening}
                      setListening={setListening}
                      sendDataToServer={voiceTextSend}
                      transcriptRef={transcriptRef}
                    />
                    <button
                      onClick={handleSend}
                      disabled={isLoading || !inputValue.trim()}
                      className="content-send-button"
                    >
                      {isLoading ? (
                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                      ) : (
                        <FontAwesomeIcon icon={'paper-plane'} size="lg" />
                      )}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>

      {/* Conditional rendering based on API response */}
      {graphsData && (
        <div className="mb-4">
          <div className="graph-card-body">
            {graphsData.graph ? (
              <div className="graph-container text-center">
                <h5 className="graph-card-title mb-2">Graph - {graphsData.graphType || "Visualization"}</h5>
                <p className="graph-card-subtitle">Interactive data visualization</p>
                <img
                  src={`data:image/png;base64,${graphsData.graph}`}
                  alt="Graph Visualization"
                  className="graph-image"
                />
              </div>
            ) : (
              <p className="graph-placeholder text-center">
                Graph visualization will appear here
              </p>
            )}
          </div>
        </div>
      )}


      {/* Original user management data table */}
      {!graphsData && tableData && gotRoles && (
        <div className="card shadow-sm">
          <div className="card-body p-0">
            <DataTables
              {...props}
              getTableFields={getTableFields}
              formFields={getFormFields}
              collectionData={tableData}
              addRequired={rolePermission && rolePermission === "Edit"}
              editRequired={rolePermission && rolePermission === "Edit"}
              deleteRequired={rolePermission && rolePermission === "Edit"}
              viewRequired={rolePermission && rolePermission === "Edit"}
              exportRequired={rolePermission && rolePermission === "Edit" ? false : false}
              sample={true}
              actionsTypes={[
                {
                  name: "Delete",
                  options: [
                    {
                      label: "Delete",
                      value: "Delete",
                      show: rolePermission && rolePermission === "Edit",
                      multiple: true,
                    },
                  ],
                },
              ]}
              settingsRequired={true}
              filterRequired={false}
              gridRequried={true}
              exportToCsv={true}
              dateSearchRequired={undefined}
              searchInDateRangeField={"undefined"}
              sampleFilePath={filePath.employees}
              setData={() => { }}
              editSelectedRecord={editSelectedRecord}
              addSelectedRecord={addSelectedRecord}
              viewSelectedRecord={viewSelectedRecord}
              globalSearch={"First Name / Last Name / Email / Role "}
              displayName="Users"
              type="User"
              routeTo={apiCalls.employees}
              sideFormLeftOrRight=""
              displayViewOfForm="modal"
              apiResponseKey={apiCalls.employees?.toLowerCase()}
              apiUrl={apiCalls.employees}
              selectedId={params.id}
              buttonToolTips={{ add: 'Add User' }}
              softUpdate={true}
              actionOverlayPanel={false}
            />
          </div>
        </div>
      )}


      <style jsx>{`
        .min-vh-75 {
          min-height: 75vh;
        }
      `}</style>
    </div>
  );
};

export default FilesAnalysis;